import swal from "sweetalert";
import axiosInstance from "../api";
import { setBanners, setBannerDetail } from "../../reusableSlice";

const BANNERS_URL = "admin/banners/";

const showError = (message) =>
  swal({ text: message, icon: "error", button: "Close", timer: 1800 });

const showSuccess = (message) =>
  swal({ text: message, icon: "success", button: "Close", timer: 1500 });

const errorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export const getBanners = (params = {}, setLoading) => async (dispatch) => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.get(BANNERS_URL, { params });
    if (response?.data?.status) {
      const raw = response.data.response;
      dispatch(
        setBanners({
          data: Array.isArray(raw?.data) ? raw.data : [],
          pagination: raw?.pagination || null,
        }),
      );
    } else {
      dispatch(setBanners({ data: [], pagination: null }));
    }
  } catch {
    dispatch(setBanners({ data: [], pagination: null }));
  } finally {
    setLoading?.(false);
  }
};

export const getBannerDetail = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`${BANNERS_URL}${id}`);
    if (response?.data?.status) {
      dispatch(setBannerDetail(response.data.response || null));
    } else {
      dispatch(setBannerDetail(null));
    }
  } catch {
    dispatch(setBannerDetail(null));
  }
};

export const createBanner = (payload, setLoading, onSuccess) => async () => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.post(BANNERS_URL, payload);
    if (response?.data?.status) {
      showSuccess(response.data.response?.message || "Banner created");
      onSuccess?.(response.data.response);
    } else {
      showError(response?.data?.message || "Failed to create banner");
    }
  } catch (err) {
    showError(errorMessage(err, "Failed to create banner"));
  } finally {
    setLoading?.(false);
  }
};

// Backend contract: partial update — send `id` plus only the fields to change
// in the body (not in the URL). Mirrors the existing /admin/sections/ PUT.
export const updateBanner = (payload, setLoading, onSuccess) => async () => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.put(BANNERS_URL, payload);
    if (response?.data?.status) {
      showSuccess(response.data.response?.message || "Banner updated");
      onSuccess?.(response.data.response);
    } else {
      showError(response?.data?.message || "Failed to update banner");
    }
  } catch (err) {
    showError(errorMessage(err, "Failed to update banner"));
  } finally {
    setLoading?.(false);
  }
};

export const deleteBanner = (id, setLoading, onSuccess) => async () => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.delete(`${BANNERS_URL}${id}`);
    if (response?.data?.status) {
      showSuccess(response.data.response?.message || "Banner deleted");
      onSuccess?.();
    } else {
      showError(response?.data?.message || "Failed to delete banner");
    }
  } catch (err) {
    showError(errorMessage(err, "Failed to delete banner"));
  } finally {
    setLoading?.(false);
  }
};
